import { TrackJS } from 'trackjs';
import h from './helpers/common';
import user from './helpers/user';
import { store } from './store';

export const loadInitApis = function (config) {
    /* eslint no-async-promise-executor: "off" */
    return new Promise(async (resolve) => {
        try {
            h.clearStoreStatuses();
            const userInfo = user.getUserInfo();

            await h.isAllowedForKids();

            // Adding device type class in <body>
            if (h.isMobileAndTablet()) {
                document.querySelector('body')?.classList.add('device');
            }

            if (userInfo && config.trackJs !== undefined && config.trackJs.token !== undefined && TrackJS) {
                TrackJS.addMetadata('userId', userInfo.username);
            }
            h.isAllowedCountry();
            // Set user context data
            user.setUserActiveSubscribedGuids();
            user.setUserTierConfig();
            user.setUserTierStatus();

            resolve({
                config,
                store,
            });
        } catch (err) {
            if (err?.data?.code === '9006') {
                resolve({ refreshTokenError: true });
            } else {
                resolve({ error: true });
            }
        }
    });
};
